import { createError } from './utils/create-error';
import { getNestedValue } from './utils/get-nested-value';
export function handleFieldOperators(document, fieldName, condition, operators) {
    const fieldValue = getNestedValue(document, fieldName);
    if (typeof condition === 'object' &&
        condition !== null &&
        !Array.isArray(condition)) {
        const subObject = condition;
        for (const [opKey, opValue] of Object.entries(subObject)) {
            const opFunction = operators[opKey];
            if (!opFunction) {
                createError(`Unsupported operator: ${opKey}`);
            }
            if (!opFunction(fieldValue, opValue, document)) {
                return false;
            }
        }
    }
    else {
        const eqFunction = operators['$eq'];
        if (!eqFunction) {
            createError('Missing $eq operator definition.');
        }
        if (!eqFunction(fieldValue, condition, document)) {
            return false;
        }
    }
    return true;
}
